import { QueryFactory } from "../../../../Common";
export const QGetTournaments = QueryFactory("GetTournaments");
//# sourceMappingURL=QGetTournaments.js.map